/*
 * Copyright (C) 2019 - Potentially Ltd
 *
 * Please see distribution for license.
 */

/* eslint-disable max-len */
/** Injection token for the data service, used by angular to decide whether to inject Mock or API service at runtime. */
import { InjectionToken } from '@angular/core';
import {
  AddCompetenceLevelRequest,
  CompetenceLevel,
  CompetenceModel,
  CompetencyV3,
  CreateCompetenceRequest,
  SaveCompetencyRequest,
} from '../../models/competence/competence.model';
import { ObservableResult } from '../../store';

export const CORE_COMPETENCE_DATA_SERVICE = new InjectionToken<CompetenceDataService>('[competence] coreCompetenceDataService');

/** The service handling competence CRUD operations. */
export interface CompetenceDataService {
  /**
   * Creates a competence
   */
  createCompetence(request: CreateCompetenceRequest): ObservableResult<CompetenceModel>;

  /**
   * Updates a competence
   */
  updateCompetence(competenceUid: string, request: CreateCompetenceRequest): ObservableResult<CompetenceModel>;

  /**
   * Add competence level to specified competence {competenceUid}
   */
  addCompetenceLevel(competenceUid: string, request: AddCompetenceLevelRequest): ObservableResult<CompetenceModel>;

  /**
   * Updates competence level for specified competence {competenceUid} and competence level {competenceLevelUid}
   */
  updateCompetenceLevel(
    competenceUid: string,
    competenceLevelUid: string,
    request: AddCompetenceLevelRequest,
  ): ObservableResult<CompetenceLevel>;

  /**
   * Gets competence by Uid
   */
  getCompetenceById(competenceUid: string): ObservableResult<CompetenceModel>;

  /**
   * Gets all competencies for current organization
   */
  getOrganizationCompetencies(): ObservableResult<CompetenceModel[]>;

  /**
   * Assigns competence to a tag
   */
  connectCompetenceToTag(tagUid: string, competencyUid: string): ObservableResult<void>;

  /**
   * Gets the predefined (system-owned) global competency scales.
   */
  getGlobalCompetencies(): ObservableResult<CompetencyV3[]>;

  /**
   * Creates a new org competency with all its levels in a single call.
   */
  saveCompetency(request: SaveCompetencyRequest): ObservableResult<CompetencyV3>;

  /**
   * Updates an existing org competency, fully replacing its levels. Creator-only.
   */
  updateCompetencyFull(competencyUid: string, request: SaveCompetencyRequest): ObservableResult<CompetencyV3>;
}
